const lastUpdate = '2026-05-17'; //YYYY-MM-DD
export const helpTitle = 'IntelliFire EasyMap Help';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>Welcome to IntelliFire EasyMap! This application provides a suite of tools to help you manage and analyze geographic data. Whether you need to measure distances, convert coordinates, or access various mapping tools, EasyMap has you covered.</p>

<h2>Getting Started</h2>
<p>To get started with IntelliFire EasyMap, follow these steps:</p>
<ol>
  <li><strong>Launch the Application:</strong>
    <ul>
      <li>Open IntelliFire EasyMap in your web browser.</li>
      <li>Ensure you have a stable internet connection for the best experience.</li>
    </ul>
  </li>
  <li><strong>Navigate the Interface:</strong>
    <ul>
      <li>Use the toolbar on the left to access various tools and features.</li>
      <li>Click on the icons to open the corresponding tools.</li>
    </ul>
  </li>
</ol>

<h2>Tools and Features</h2>
<p>IntelliFire EasyMap offers a variety of tools to assist you with your mapping needs:</p>
<ul>
  <li><strong>Measuring Tool:</strong> Measure distances, bearings, and areas directly on the map. Click the <i class="fas fa-ruler-combined"></i> icon to start measuring.</li>
  <li><strong>Lat Long Converter:</strong> Convert latitude and longitude coordinates between different formats. Click the <i class="fas fa-map-marker-alt"></i> icon to open the converter.</li>
  <li><strong>Toolbox:</strong> Access additional tools and features. Click the <i class="fas fa-tools"></i> icon to open the toolbox.</li>
</ul>

<h2>Using the Tools</h2>
<p>Each tool in IntelliFire EasyMap is designed to be intuitive and easy to use. Here are some general instructions:</p>
<ol>
  <li><strong>Select a Tool:</strong>
    <ul>
      <li>Click on the icon of the tool you want to use.</li>
      <li>The tool's interface will open, allowing you to interact with it.</li>
    </ul>
  </li>
  <li><strong>Follow On-Screen Instructions:</strong>
    <ul>
      <li>Each tool provides on-screen instructions to guide you through its usage.</li>
      <li>Follow the prompts to complete your tasks.</li>
    </ul>
  </li>
  <li><strong>Access Help:</strong>
    <ul>
      <li>If you need assistance with a specific tool, click the help icon <i class="fas fa-circle-question"></i> within the tool's interface.</li>
      <li>A help dialog will open, providing detailed instructions and information.</li>
    </ul>
  </li>
  <li><strong>Explorer Windows Remember Your Layout:</strong>
    <ul>
      <li>Each explorer (VAR, Hotspots, Lightning, Weather, etc.) saves your preferences automatically: sort column, active filters, column widths, rows per page, and window position and size.</li>
      <li>Your layout sticks between sessions and is kept separately for each signed-in user.</li>
      <li>To return an explorer to its defaults, click the reset icon <i class="fas fa-rotate-left"></i> beside the window title. This clears just that explorer's saved layout — other explorers are untouched.</li>
    </ul>
  </li>
  <li><strong>Navigating Explorer Results:</strong>
    <ul>
      <li>Use the <strong>First</strong>, <strong>Previous</strong>, <strong>Next</strong>, and <strong>Last</strong> buttons in the footer to move through pages of results.</li>
      <li>To jump directly to a specific page, click the page number, type the page you want, and press <strong>Enter</strong> (or click away).</li>
      <li>Change how many rows you see per page using the <strong>Rows per page</strong> dropdown in the footer — your choice is remembered for that explorer.</li>
    </ul>
  </li>
</ol>

<h2>Additional Information</h2>
<p>For further assistance, please refer to the documentation or contact support. We are here to help you make the most of IntelliFire EasyMap.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`

export default helpContent;